import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Search, Bell, Bookmark, User, Plus, Mail } from 'lucide-react';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { nip19 } from 'nostr-tools';

interface MobileBottomNavProps {
  onOpenCompose: () => void;
}

export function MobileBottomNav({ onOpenCompose }: MobileBottomNavProps) {
  const { user } = useCurrentUser();
  const userNpub = user ? nip19.npubEncode(user.pubkey) : '';

  return (
    <div className="fixed bottom-0 left-0 right-0 h-14 bg-background border-t border-border flex items-center justify-around z-50 md:hidden px-1 overflow-x-hidden safe-bottom">
      <NavLink 
        to="/" 
        className={({ isActive }) => `p-1.5 ${isActive ? 'text-sky-500' : 'text-foreground/80'}`}
      >
        <Home className="size-5.5 stroke-[2.2px]" />
      </NavLink>

      <NavLink 
        to="/explore" 
        className={({ isActive }) => `p-1.5 ${isActive ? 'text-sky-500' : 'text-foreground/80'}`}
      >
        <Search className="size-5.5 stroke-[2.2px]" />
      </NavLink>

      {user ? (
        <NavLink 
          to="/chat" 
          className={({ isActive }) => `p-1.5 ${isActive ? 'text-sky-500' : 'text-foreground/80'}`}
        >
          <Mail className="size-5.5 stroke-[2.2px]" />
        </NavLink>
      ) : (
        <div className="w-8" />
      )}

      {user && (
        <button 
          onClick={onOpenCompose}
          className="size-9 rounded-full bg-sky-500 hover:bg-sky-600 text-white flex items-center justify-center -translate-y-3 shadow-lg active:scale-95 transition-transform shrink-0"
        >
          <Plus className="size-5" />
        </button>
      )}

      <NavLink 
        to="/notifications" 
        className={({ isActive }) => `p-1.5 ${isActive ? 'text-sky-500' : 'text-foreground/80'}`}
      >
        <Bell className="size-5.5 stroke-[2.2px]" />
      </NavLink>

      {user ? (
        <NavLink 
          to={`/${userNpub}`} 
          className={({ isActive }) => `p-1.5 ${isActive ? 'text-sky-500' : 'text-foreground/80'}`}
        >
          <User className="size-5.5 stroke-[2.2px]" />
        </NavLink>
      ) : (
        <div className="w-8" />
      )}
    </div>
  );
}
